import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { API_URLS } from "../../config/apiUrls";
import axiosInstance, { baseUrl } from "../../config/axios";
import { Active, Inactive, Unmaped } from "../../shared/ActivaInactive";
import AddProductVariant from "./AddProductVariant";
import AddSpecification from "./AddSpecifications";
import ManageProductVariant from "./ManageProductVariant";
import MultipleVariantImage from "./MultipleVariantImage";
import ProductVariantByExcel from "./ProductVariantByExcel";
import SelectVariantImage from "./SelectMultipleImage";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import { CustomIconButton } from "../../shared/CustomIconButton";
import CustomSelect from "../../shared/CustomSelect";
import CustomSelect2 from "../../shared/CustomSelect2";

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const AddVAriantList = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const [count, setCount] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [open1, setOpen1] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [colorVarient, setColorVarient] = useState([]);
  const [storeVarient, setStoreVarient] = useState([]);
  const [otherVarient, setOtherVarient] = useState([]);
  const [type1VariantComboList, setType1VariantComboList] = useState([]);
  const [type2VariantComboList, setType2VariantComboList] = useState([]);
  const [type3VariantComboList, setType3VariantComboList] = useState([]);
  const [page, setPage] = useState(1);
  const [productId, setProductId] = useState("");
  const [ids, setIds] = useState(null);

  // excel formate dataList start
  const [categoryData, setCategoryData] = useState([]);

  // const [colorCategoryData, setColorCategoryData] = useState([]);
  // const [storageCategoryData, setStorageCategoryData] = useState([]);
  // const [otherCategoryData, setOtherCategoryData] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  // excel formate dataList end

  // add product varient start
  const [productIdManage, setProductIdManage] = useState("");
  const [rowData, setRowData] = useState({});

  const [searchQuery, setSearchQuery] = useState("");
  const StoreID = localStorage.getItem("store_id");
  const [variantId, setVariantId] = useState("");
  const [multipleImageModal, setMultipleImageModal] = useState(false);
  const [selectMultipleImageModal, setSelectMultipleImageModal] =
    useState(false);
  const handleOpenMultipleImage = () => {
    setMultipleImageModal(true);
  };

  // multiple add product variant start

  const [searchParams, setSearchParams] = useState("");
  const [searchParamsManage, setSearchParamsManage] = useState("");

  const [searchStorage, setSearchStorage] = useState("");
  const [searchColor, setSearchColor] = useState("");
  const [searchOther, setSearchOther] = useState("");
  const [category, setCategory] = useState();
  const [syncStatus, setSyncStatus] = useState(null);

  const handleOpen4 = () => setOpen4(true);
  const handleOpen5 = () => setOpen5(true);

  const inventoryData = useCallback(() => {
    axiosInstance
      .get(`${API_URLS.productApi}`, {
        params: {
          store_id: StoreID,
          search: searchParams || searchParamsManage,
        },
      })
      .then((response) => {
        setProductData(response?.data?.data);
        setCategoryId(
          response?.data?.data?.filter((item) => item.id === productId)?.[0]
            ?.main_category
        );
        console.log(
          "|||||||||||||||",
          productId,
          categoryId,
          response?.data?.data
        );
      })
      .catch((error) => {
        //
      });
  }, [StoreID, searchParams, ids, productId, searchParamsManage]);

  useEffect(() => {
    inventoryData();
  }, [inventoryData, ids, searchParams, searchParamsManage]);

  const addvarientData = useCallback(() => {
    axiosInstance
      .get(`${API_URLS.productVariantApi}`, {
        params: {
          store_id: storeId,
          page: page,
          search: searchQuery,
          category_id: category,
          merchant_product_status: syncStatus,
        },
      })
      .then((response) => {
        setData(response?.data?.data);
        setCount(response?.data?.count);
        setCurrentPage(response?.data?.current_page);
        setTotalPage(response?.data?.total_pages);
      })
      .catch((error) => {
        //
      });
  }, [page, searchQuery, storeId, category, syncStatus]);

  useEffect(() => {
    addvarientData();
  }, [addvarientData, page, searchQuery]);

  const Variantcolor = useCallback(
    (searchColor) => {
      axiosInstance
        .get(`${API_URLS.colorVariantApi}`, {
          params: {
            // product_id: String(productId) || rowData?.product?.id,
            // store_id: storeId,
            category: categoryId,
            search: searchColor,
          },
        })
        .then((response) => {
          setColorVarient(response?.data?.data);
        })
        .catch((error) => {
          //
        });
    },
    [categoryId, productId, ids, searchColor, rowData?.product?.id, storeId]
  );

  useEffect(() => {
    if (categoryId || ids || searchColor) {
      Variantcolor(searchColor);
    }
  }, [Variantcolor, categoryId, ids, searchColor, productId, rowData]);

  const Variantstorage = useCallback(
    (searchStorage) => {
      axiosInstance
        .get(`${API_URLS.storageVariantApi}`, {
          params: {
            // product_id: String(productId) || rowData?.product?.id,
            // store_id: storeId,
            category: categoryId,
            search: searchStorage,
          },
        })
        .then((response) => {
          setStoreVarient(response?.data?.data);
        })
        .catch((error) => {
          //
        });
    },
    [categoryId, productId, ids, rowData?.product?.id, searchStorage, storeId]
  );

  useEffect(() => {
    if (categoryId || ids || searchStorage) {
      Variantstorage(searchStorage);
    }
  }, [Variantstorage, categoryId, ids, searchStorage, productId, rowData]);

  const OtherVarint = useCallback(
    (searchOther) => {
      axiosInstance
        .get(`${API_URLS.otherVariantApi}`, {
          params: {
            // product_id: String(productId) || rowData?.product?.id,
            // store_id: storeId,
            category: categoryId,
            search: searchOther,
          },
        })
        .then((response) => {
          setOtherVarient(response?.data?.data);
        })
        .catch((error) => {
          //
        });
    },
    [productId, rowData?.product?.id, ids, categoryId, searchOther, storeId]
  );

  useEffect(() => {
    if (categoryId || ids || searchOther) {
      OtherVarint(searchOther);
    }
  }, [OtherVarint, categoryId, ids, searchOther, productId, rowData]);

  const VariantCombo = useCallback(
    (searchOther) => {
      axiosInstance
        .get(`${API_URLS.variantCombo}`, {
          params: {
            product_id: String(productId) || rowData?.product?.id,
            store_id: storeId,
            category: categoryId,
            search: searchOther,
          },
        })
        .then((response) => {
          setType1VariantComboList(response?.data?.data?.colors);
          setType2VariantComboList(response?.data?.data?.others);
          setType2VariantComboList(response?.data?.data?.storages);
        })
        .catch((error) => {
          //
        });
    },
    [productId, rowData?.product?.id, ids, categoryId, searchOther, storeId]
  );

  // useEffect(() => {
  //   if (categoryId || ids) {
  //     VariantCombo(searchOther);
  //   }
  // }, [VariantCombo, categoryId, ids, searchOther, productId, rowData]);

  const deleteFunctionality = (id) => {
    const delBody = window.confirm(
      "Are You Sure Delete this Product Variant...!"
    );
    if (delBody === true) {
      axiosInstance
        .delete(`${API_URLS.productVariantApi}`, {
          data: {
            product_variant_ids: [id],
          },
        })
        .then((response) => {
          if (response.data.response_code === 200) {
            toast.success(response.data.message);
            addvarientData();
          }
        })
        .catch((error) => {
          //
        });
    }
  };

  const Enable = (id) => {
    axios
      .post(
        `${baseUrl}api/admin/product-variant-enable-disable-admin/`,
        { product_variants_id: id },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message);
        addvarientData();
      })
      .catch((error) => {
        //
      });
  };

  const subscriptionEnable = (event, id) => {
    event.preventDefault();
    axios
      .post(
        `${baseUrl}api/admin/activate-store-product-varaint-for-subscription/`,
        { id: id },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message);
        addvarientData();
      })
      .catch((error) => {
        //
      });
  };

  const categoryList = () => {
    axiosInstance
      .post(
        `${baseUrl}api/admin/multivendor-show-main-category-list/`,
        {}
      )
      .then((response) => {
        setCategoryData(response?.data?.main_category_data);
      })
      .catch((error) => {
        //
      });
  };
  useEffect(() => {
    categoryList();
  }, []);

  // const categoryVariantcolor = useCallback(() => {
  //   axiosInstance
  //     .get(`${API_URLS.colorVariantApi}`, {
  //       category_id: String(categoryId),
  //       store_id: storeId,
  //     })
  //     .then((response) => {
  //       setColorCategoryData(response?.data?.data);
  //     })
  //     .catch((error) => {
  //       //
  //     });
  // }, [categoryId, storeId]);

  // useEffect(() => {
  //   categoryVariantcolor();
  // }, [categoryId, categoryVariantcolor]);

  // const categoryVariantstorage = useCallback(() => {
  //   axiosInstance
  //     .get(`${API_URLS.storageVariantApi}`, {
  //       params: {
  //         category_id: String(categoryId),
  //         store_id: storeId,
  //       },
  //     })
  //     .then((response) => {
  //       setStorageCategoryData(response?.data?.data);
  //     })
  //     .catch((error) => {
  //       //
  //     });
  // }, [categoryId, storeId]);

  // useEffect(() => {
  //   if (categoryId) {
  //     categoryVariantstorage();
  //   }
  // }, [categoryId, categoryVariantstorage]);

  // const CategoryOtherVarint = useCallback(() => {
  //   axiosInstance
  //     .get(`${API_URLS.otherVariantApi}`, {
  //       params: {
  //         category_id: String(categoryId),
  //         store_id: storeId,
  //       },
  //     })
  //     .then((response) => {
  //       setOtherCategoryData(response?.data?.data);
  //     })
  //     .catch((error) => {
  //       //
  //     });
  // }, [categoryId, storeId]);

  // useEffect(() => {
  //   CategoryOtherVarint();
  // }, [CategoryOtherVarint, categoryId]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Product Variant List
          </p>
        </div>
        <div className="">
          <Button
            variant="outlined"
            className="!m-2"
            color="primary"
            size="small"
            onClick={handleOpen5}
          >
            <AddIcon />
            Manage Product Variant Combination
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex gap-3">
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="mx-3 text-red-500 flex items-center">
              <FormControl
                fullWidth
                size="small"
                className="!w-56 !text-black !z-50"
              >
                <InputLabel id="sync-status-label">
                  Select Sync Status
                </InputLabel>
                <Select
                  labelId="sync-status-label"
                  id="sync-status"
                  value={syncStatus}
                  onChange={(e) => setSyncStatus(e.target.value)}
                  label="Select Sync Status"
                >
                  {/* Placeholder */}
                  <MenuItem value={null}>Show All Products</MenuItem>

                  {/* Sync options */}
                  <MenuItem value={true}>Show Synced Products</MenuItem>
                  <MenuItem value={false}>Show Not Synced Products</MenuItem>
                </Select>
              </FormControl>

              <FormControl
                fullWidth
                size="small"
                className="!w-56 !text-black !z-50 !ml-2"
              >
                <InputLabel id="sync-category-label">
                  Select Category
                </InputLabel>
                <Select
                  labelId="sync-category-label"
                  id="sync-status"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  label="Select Category Status"
                >
                  {/* Placeholder */}
                  <MenuItem value={null}>Select Category</MenuItem>

                  {/* Sync options */}

                  {categoryData?.map((i) => {
                    return <MenuItem value={i.id}>{i.category}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              {/* <CustomSelect
                size="small"
                className="!w-64 !text-black"
                id="category"
                placeholder="Select Category"
                onChange={(e) => setCategory(e.target.value)}
                // isLoading={isState}
              >
                <option value="">Select Category</option>

                {categoryData?.map((i) => {
                  return <option value={i.id}>{i.category}</option>;
                })}
              </CustomSelect> */}

              <Button
                variant="outlined"
                className="!mx-2"
                color="primary"
                onClick={handleOpen4}
              >
                <AddIcon />
                Upload by excel
              </Button>
              <AddProductVariant
                open={open1}
                setOpen={setOpen1}
                ids={ids}
                setIds={setIds}
                rowData={rowData}
                setRowData={setRowData}
                storeId={storeId}
                productId={productId}
                setProductId={setProductId}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                addvarientData={addvarientData}
                productData={productData}
                colorVarient={colorVarient}
                otherVarient={otherVarient}
                storeVarient={storeVarient}
                setCategory={setCategoryId}
                searchColor={searchColor}
                setSearchColor={setSearchColor}
                searchOther={searchOther}
                setSearchOther={setSearchOther}
                searchStorage={searchStorage}
                setSearchStorage={setSearchStorage}
              />
              <ProductVariantByExcel
                open={open4}
                setOpen={setOpen4}
                categoryId={categoryId}
                setCategoryId={setCategoryId}
                categoryData={categoryData}
                productData={productData}
                // colorCategoryData={colorCategoryData}
                // storageCategoryData={storageCategoryData}
                // otherCategoryData={otherCategoryData}
                colorVarient={colorVarient}
                storeVarient={storeVarient}
                otherVarient={otherVarient}
                productId={productIdManage}
                searchColor={searchColor}
                setSearchColor={setSearchColor}
                searchStorage={searchStorage}
                setSearchStorage={setSearchStorage}
                searchOther={searchOther}
                setSearchOther={setSearchOther}
                setProductId={setProductIdManage}
                searchParamsManage={searchParamsManage}
                setSearchParamsManage={setSearchParamsManage}
              />
              <ManageProductVariant
                open={open5}
                setOpen={setOpen5}
                searchParamsManage={searchParamsManage}
                setSearchParamsManage={setSearchParamsManage}
                productId={productIdManage}
                setProductId={setProductId}
                productData={productData}
                searchColor={searchColor}
                setSearchColor={setSearchColor}
                searchStorage={searchStorage}
                setSearchStorage={setSearchStorage}
                searchOther={searchOther}
                setSearchOther={setSearchOther}
                colorVarient={colorVarient}
                storeVarient={storeVarient}
                otherVarient={otherVarient}
                type1VariantComboList={type1VariantComboList}
                type2VariantComboList={type2VariantComboList}
                type3VariantComboList={type3VariantComboList}
                storeId={StoreID}
                addvarientData={addvarientData}
                setCategory={setCategoryId}
              />
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%" }}
          className="!text-black !h-[77vh] !mx-auto !bg-white overflow-auto"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="  text-sm !leading-4">
                    STOCK
                    {/* <span className="text-sm">(Enable/disabled)</span> */}
                  </div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className=" text-sm !leading-4">
                    SUBSCRIPTION
                    {/* <div className="text-sm">(enable/disabled)</div> */}
                  </div>
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className=" text-sm !leading-4">EDIT</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    borderLeft: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className=" text-sm">PRODUCT</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className=" text-sm">VARIANT</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-40 text-sm  !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-40 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  VARIANT IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-centerw-40 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  SELECT IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  SPF
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  !text-gray-800 !font-bold"
                >
                  <div className=" text-sm !leading-4">A.P.</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className=" text-sm !leading-4">QTY</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="  text-sm !leading-4">MRP</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  SGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  CGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  IGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  length
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  breadth
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  height
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  weight
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center w-24 text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  rating
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  Sync Google Merchant
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center  text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  REC.
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center text-sm !leading-4 !text-gray-800 !font-bold"
                >
                  Deal Product
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="  text-sm !leading-4">Deal Start Date</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className=" text-sm !leading-4">Deal End Date</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div className="mx-auto">
                        <Switch
                          defaultChecked={row?.website_is_active}
                          onChange={(event) => Enable(row?.id)}
                        />
                      </div>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div className="mx-auto">
                        <Switch
                          defaultChecked={row?.is_subscription_active}
                          onChange={(event) =>
                            subscriptionEnable(event, row?.id)
                          }
                        />
                      </div>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div className="flex justify-center gap-2">
                        <BorderColorIcon
                          className="text-green-400"
                          onClick={() => {
                            setRowData(row);
                            setIds(row?.id);
                            setSearchColor(row?.color_name);
                            setSearchStorage(row?.storage_name);
                            setSearchOther(row?.other_name);
                            setSearchParams(row?.product_name);
                          }}
                        />

                        <DeleteForeverIcon
                          className="text-red-500"
                          onClick={() => deleteFunctionality(row?.id)}
                        />
                      </div>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        borderLeft: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.product_name ? row?.product_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.product_variant_name
                        ? row?.product_variant_name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.variant_image ? (
                        <img
                          alt=""
                          src={row?.variant_image}
                          className="w-8 h-8 mx-auto"
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      onClick={() => {
                        setVariantId(row.id);

                        handleOpenMultipleImage();
                      }}
                    >
                      <CustomIconButton
                        className="cursor-pointer !shadow-xl !rounded-2xl !text-sm"
                        size="small"
                      // variant="contained"
                      >
                        <AddToPhotosIcon className="cursor-pointer !text-sky-500 !text-3xl" />
                      </CustomIconButton>
                    </TableCell>
                    <TableCell
                      className="!text-center "
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      onClick={() => {
                        setVariantId(row.id);
                        setSelectMultipleImageModal(true);
                      }}
                    >
                      <CustomIconButton
                        className="cursor-pointer !rounded-2xl !shadow-xl   !text-sm"
                        size="small"
                      // variant="contained"
                      >
                        <AddPhotoAlternateIcon className="cursor-pointer !text-green-600 !text-3xl" />
                      </CustomIconButton>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <AddSpecification
                        variant={row}
                        className={"update-manage-specifications"}
                      />
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      ₹ {row?.price ? row?.price : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.quantity ? row?.quantity : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      ₹ {row?.mrp ? row?.mrp : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.sgst_percent ? row?.sgst_percent + " %" : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.sgst_percent ? row?.sgst_percent + " %" : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.sgst_percent ? row?.sgst_percent * 2 + " %" : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.length + " cm"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.breadth + " cm"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.height + " cm"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.weight + " cm"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.rating}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Chip
                        label={`${row?.merchant_product_status ? "True" : "False"
                          }`}
                        color={`${row?.merchant_product_status ? "success" : "warning"
                          }`}
                      />
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div className="flex justify-center w-full">
                        {row.recommended === null ? (
                          <Unmaped />
                        ) : row.recommended === true ? (
                          <Active />
                        ) : (
                          <Inactive />
                        )}
                      </div>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div className="flex justify-center w-full p-4">
                        {row.deal_product === null ? (
                          <Unmaped />
                        ) : row.deal_product === true ? (
                          <Active />
                        ) : (
                          <Inactive />
                        )}
                      </div>
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.deal_start_date
                        ? row?.deal_start_date?.slice(0, 10)
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.deal_end_date
                        ? row?.deal_end_date?.slice(0, 10)
                        : "--"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <button className="!float-left text-sm mt-3">
            <p className="px-4">
              Total Count : <span className="text-red-500">{count}</span>
            </p>
          </button>

        </TableContainer>


        {totalPage !== 1 && (
          <div className="flex justify-center p-2">
            <Pagination
              page={currentPage}
              size="small"
              count={totalPage}
              variant="outlined"
              color="primary"
              onChange={handleChange}
            />
          </div>
        )}
        <hr />
      </div>

      <MultipleVariantImage
        open={multipleImageModal}
        handleClose={() => {
          setMultipleImageModal(false);
          setVariantId(null);
        }}
        variantId={variantId}
      />
      <SelectVariantImage
        open={selectMultipleImageModal}
        handleClose={() => {
          setSelectMultipleImageModal(false);
          setVariantId(null);
        }}
        variantId={variantId}
      />
    </div>
  );
};

export default AddVAriantList;
